<template>
    <div class="board">
        <div class="bar">
            <b-icon icon="file-earmark-person" class="icon"></b-icon>
            <span>รายชื่อผู้ใช้</span>
        </div>

        <div class="content">
            <div class="mb-4 text-center">
                <button class="btn btn-main" @click="openModalStaff(null)">เพิ่มทีมงาน</button>
            </div>

            <loader-spinner :isDisplay="isLoading" class="mt-4 mb-4"></loader-spinner>

            <template v-if="!isShowNetworkError">
                <perfect-scrollbar>
                    <table>
                        <thead>
                            <tr>
                                <th class="action-column"></th>
                                <th>อีเมล</th>
                                <th>ชื่อ-นามสกุล</th>
                                <th>เชื่อมต่อล่าสุด</th>
                                <th>บทบาท</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in staffList" :key="index">
                                <td class="text-center">
                                    <button class="icon" @click="openModalStaff(item.id)" v-if="item.level > 1"><b-icon icon="pencil"></b-icon></button>
                                    <button class="icon" @click="deleteStaff(item.id)" v-if="item.level > 1"><b-icon icon="trash"></b-icon></button>
                                </td>
                                <td>{{ item.email }}</td>
                                <td>{{ item.staffName }}</td>
                                <td>{{ $AppUtility.displayTimeFormat(item.lastLogin) }}</td>
                                <td>{{ getStaffText(item.level) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </perfect-scrollbar>
            </template>
            <template v-else>
                <div class="no-data">
                    <b-icon icon="exclamation-diamond"></b-icon>
                    <span>ข้อมูลส่วนต้องใช้การเชื่อมต่ออินเทอร์เน็ต โปรดตรวจสอบการเชื่อมต่อของอุปกรณ์ที่ท่านใช้</span>
                </div>
            </template>
        </div>

        <store-modal-staff :isDisplay="isShowModalStaff" :staffId="selectedStaff" @hide="closeModalStaff()"></store-modal-staff>
    </div>
</template>

<script>
import StoreModalStaff from '@/components/store/ModalStaff';
import Helper from '@/resources/Helper';

export default {
    components: {
        StoreModalStaff
    },
    data() {
        return {
            isLoading: false,
            isShowNetworkError: false,
            isShowModalStaff: false,
            staffList: [],
            selectedStaff: null
        }
    },
    mounted() {
        this.loadStaff();
    },
    methods: {
        openModalStaff(id) {
            this.selectedStaff = id;
            this.isShowModalStaff = true;
        },
        closeModalStaff() {
            this.isShowModalStaff = false;
        },
        async loadStaff() {
            this.staffList = [];
            this.isLoading = true;

            const result = await Helper.postAPI(Helper.getApiUrl(), '/api/store/get-staff', {}, Helper.getHeaderToken());
            
            this.isLoading = false;

            if (result) {
                this.staffList = result.data;
            }
        },
        getStaffText(level) {
            let text = '';

            switch (level) {
                case 1:
                    text = 'บัญชีหลัก'; 
                    break;

                case 2:
                    text = 'เจ้าของร้าน'; 
                    break;

                case 3:
                    text = 'ทีมงาน'; 
                    break;
            }

            return text;
        },
        async deleteStaff(staffId) {
            this.$swal({
                title: 'ลบชื่อผู้ใช้?',
                text: 'โปรดยืนยันว่าต้องการลบชื่อผู้ใช้',
                icon: 'question',
                showCancelButton: true
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const loader = this.$AppUtility.renderLoadBackdrop();
                    const param = {
                        staffId: staffId
                    };

                    await Helper.postAPI(Helper.getApiUrl(), '/api/store/delete-staff', param, Helper.getHeaderToken());

                    loader.hide();

                    this.loadStaff();
                }
            });
        }
    }
}
</script>